/**
 * auth.ts — cliente de autenticación con Supabase Auth
 */
import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://hwcvxdzqvtzyhmhjafpw.supabase.co";
const SUPABASE_ANON_KEY = "sb_publishable_7KA3KM38Oq3QGn48GFX2Pw_7-eWs89v";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

